<template>
  <div class="wrapper">
    <div class="contentWebsite">
      <v-expand-transition>
        <router-view />
      </v-expand-transition>
    </div>
  </div>
</template>

<script>
export default {
  name:"Website",
  components: {},
  data() {
    return {}
  },
  methods: {},
  computed: {},
  mounted() {},
}
</script>
